module.exports = __webpack_public_path__ + "img/S__9437233.2e1a2492.jpg";